<template>
  <NuxtLayout name="v1">
    <template #main>
      <div class="flex flex-col relative">
        <div class="p-4 w-full sticky top-16 -mt-1 bg-white dark:bg-gray-700 z-40">
          <V4SearchComponent :placeholder="categories" />
        </div>
        <div class="flex flex-col">
          <div v-for="(item, index) in dataBanners" :key="index">
            <div class="custom-padding" v-if="item.banners.length" :style="getComponentStyle(item?.style)">
              <div v-if="item.layout === 'banner'">
                <V3BannerComponent :items="item" :config="item.config" />
              </div>
              <div v-if="item.layout === 'banner_full'">
                <V3BannerComponent :items="item" :config="item.config" :itemstoshow="1" />
              </div>
              <div class="pl-2" v-if="item.layout === 'card_square'">
                <h3 class="text-md font-semibold mb-4" v-if="item.config.header">
                  {{ item.header }}
                </h3>
                <V3CarouselComponent :items="item" :config="item.config" layout="square" />
              </div>
              <div class="pl-2 p-2" v-if="item.layout === 'product'">
                <h3 class="text-md font-semibold mb-4" v-if="item.config.header && item.banners.length">
                  {{ item.header }}
                </h3>
                <V3DynamicProductCarouselComponent :items="item" :config="item.config" layout="square" />
              </div>
              <div class="pl-2" v-if="item.layout === 'card_circle'">
                <h3 class="text-md font-semibold mb-4" v-if="item.config.header">
                  {{ item.header }}
                </h3>
                <V3CarouselComponent :items="item" :config="item.config" layout="circle" />
              </div>
              <div class="pl-2" v-else-if="item.layout === 'card_square_max'">
                <h3 class="text-md font-semibold mb-4" v-if="item.config.header">
                  {{ item.header }}
                </h3>
                <V3CarouselComponent :items="item" :config="item.config" layout="square" size="max" />
              </div>
              <div class="pl-2" v-if="item.layout === 'card_circle_max'">
                <h3 class="text-md font-semibold mb-4" v-if="item.config.header">
                  {{ item.header }}
                </h3>
                <V3CarouselComponent :items="item" :config="item.config" layout="circle" size="max" />
              </div>
              <div class="px-2" v-if="item.layout === 'brand_square'">
                <h3 class="text-md font-semibold mb-4" v-if="item.config.header">
                  {{ item.header }}
                </h3>
                <V3GalleryViewComponent :items="item" :config="item.config" layout="square" />
              </div>
              <div class="px-2" v-if="item.layout === 'brand_circle'">
                <h3 class="text-md font-semibold mb-4" v-if="item.config.header">
                  {{ item.header }}
                </h3>
                <V3GalleryViewComponent :items="item" :config="item.config" layout="circle" />
              </div>
              <div class="py-2" v-if="item.layout === 'strip'">
                <V3StripComponent :items="item" :config="item.config" />
              </div>
              <div class="exclude" v-if="item.layout === 'strip_image' && item.banners.length">
                <V3StripImageComponent :items="item" :config="item.config" />
              </div>
              <div class="px-2" v-if="item.layout === 'sub_category_circle'">
                <h3 class="text-md font-semibold mb-4" v-if="item.config.header">
                  {{ item.header }}
                </h3>
                <V3CategoryLayoutComponent :items="buildCategory(item.banners)" layout="circle" />
              </div>
              <div class="px-2" v-if="item.layout === 'sub_category_square'">
                <h3 class="text-md font-semibold mb-4" v-if="item.config.header">
                  {{ item.header }}
                </h3>
                <V3CategoryLayoutComponent :items="buildCategory(item.banners)" layout="square" />
              </div>
              <div class="py-2" v-if="!isSameDomain && item.layout === 'flashcard'">
                <V3FlashCardComponent :items="item" />
              </div>
            </div>
            <UDivider class="pt-1 pb-1" v-if="item.config.divider && index + 1 < dataBanners.length" :ui="{
              border: {
                base: item.config.divider
                  ? 'border-t-2'
                  : 'border-t-2 border-white dark:border-gray-900',
              },
            }" />
          </div>
        </div>
        <div class="fixed bottom-16 sm:bottom-5 left-1/2 transform -translate-x-1/2 z-50 !transform"
          v-if="isFandBItems && cartComponent && !rateComponent">
          <V3ItemsInCartComponent :itemsCount="cartItemsCount" @close="closeCartComponent" />
        </div>
        <div class="fixed bottom-20 sm:bottom-5 left-1/2 transform -translate-x-1/2 z-40 !transform"
          v-if="rateComponent">
          <button
            class="absolute -top-5 left-1/2 -translate-x-1/2 bg-green-500 text-white text-sm sm:text-base px-4 py-1 rounded shadow z-50"
            @click="OpenRating" v-if="unratedOrders.length > 1">
            + {{ unratedOrders.length - 1 }} more ▲
          </button>

          <div
            class="absolute -top-3 left-0 right-0 mx-auto scale-95 bg-gray-100 rounded-xl shadow-md z-30 h-12 pointer-events-none"
            v-if="unratedOrders.length > 1"></div>

          <V3RateOrderComponent :orders="unratedOrders" class="relative z-40" @close="closeRateOrder" />
        </div>
      </div>

      <V3PageLoaderComponent v-if="isFetchingLocation" :text="loadingMessage"
        class="dark:text-black fixed top-0 left-0 w-full h-full flex items-center justify-center bg-white/80 z-50" />
    </template>
  </NuxtLayout>
</template>

<script setup>
// Location auto-update
import {
  V3ModalComponent,
  V3PopupComponent,
  V3FlashCardComponent,
  V4ResponsivePanel,
  V3ItemsInCartComponent,
  V3RateOrderComponent
} from "#components";
import { onBeforeRouteLeave } from 'vue-router';
import { useAutoFetchLocation } from "~/composables/location/useAutoFetchLocation";
const route = useRoute()
const auth = useAuth();
const { gtag } = useGtag();
const isAuthenticated = auth && auth.access_token;
const userData = isAuthenticated
  ? {
    user_name: auth.user.first_name,
    user_phone: auth.user.phone,
    user_email: auth.user.email,
  }
  : {
    user_name: null,
    user_phone: null,
    user_email: null,
  };

const { query } = useRoute();
if (query.wk && Number(query.wk) === 1) {
  const { getCurrentLocation, emitter } = useLocationFinder();
  await getCurrentLocation();
  emitter.on("success", async (coords) => {
    await location.setCoords(coords.latitude, coords.longitude);
  });
}
const unratedOrders = ref([]);
const isDark = ref(null);
let mediaQuery
let handleSchemeChange
const runtimeConfig = useRuntimeConfig();
const location = useLocation();
const { isMobile } = useDevice();
const partnerId = runtimeConfig.public.partnerCode;
const slideover = useSlideover();
const modal = useModal();
const isSameDomain = ref(useRouter().options?.history?.state.back || false);
const isSearchBoxOpened = ref(false);
const cartComponent = ref(true);
const isFandBItems = ref(false);
const cartItemsCount = ref(0);
const rateComponent = ref(false);
const { data: partner } = await useAPIHandler("get", "/partners", {
  query: { id: partnerId },
});
const { homepage } = partner.cms;
const parentIds = homepage.map((k) => k.id);

const { isFetchingLocation, loadingMessage } = useAutoFetchLocation();

const cmsBannerQuery = {
  partner_id: partnerId,
  parent_ids: parentIds.join("|"),
};
if (location.city?.name) {
  cmsBannerQuery.cities = location.city.name;
}
if (location.area_code) {
  cmsBannerQuery.area_codes = location.area_code;
}
const { data: cmsBanners } = await useAPIHandler("get", "/cms/banners", {
  query: cmsBannerQuery,
});
const dataBanners = useBannerFilter(homepage, cmsBanners);

updateCategoryMaster()

const buildCategory = (banners) => {
  return useCategoryChunk(
    banners.map((k) => ({
      title: k.meta?.title || "",
      url: k.content?.source || "",
      href: k.action?.target || "",
    })),
    "",
    isMobile ? 2 : 1
  );
};
// const disableScroll = (event) => event.preventDefault();

const { data: categoryResult } = await useAPIHandler("get", "/categories");
const categories = categoryResult.categories
  .filter((k) => k.displayName !== "Appliances")
  .map((k) => k.displayName)
  .sort((a, b) => a.localeCompare(b));

const cart = useCart();
const cartItems = computed(() => cart.getCartItems);
// if (cartItems.value.length > 0) {
//   const result = cartItems.value.filter((item) => item.category.name == "F&B");
//   if (result.length > 0) {
//     cartItemsCount.value = result.length;
//     isFandBItems.value = true;
//   }
// }
const closeCartComponent = () => {
  cartComponent.value = false;
};

gtag("event", "home_screen_event", {
  action: "view",
  city: location?.city?.name,
  area_code: location?.area_code,
  ...userData,
});

useSeoMeta({
  title: "Homepage",
});
const toast = useToast();
const alreadyVisited = ref(false);
const OpenRating = () => {
  if (isMobile) {
    slideover.open(V3PopupComponent, {
      component: "rating",
      data: unratedOrders,
      onClose: slideover.close,
    });
  } else {
    modal.open(V3ModalComponent, {
      component: "rating",
      data: unratedOrders,
      onClose: modal.close,
    });
  }
}

const getUnratedOrders = async () => {
  const result = await useAPIHandler(
    "post",
    "/ratings/user-orders",
    {
      auth: true,
    }
  );

  if (result.data && result.data.data.length > 0) {
    rateComponent.value = true;
    unratedOrders.value = result.data.data;
    gtag('event', 'rating_popup_seen', {
      ...userData,
    });
  }
};

const getComponentStyle = (style) => {
  if (isDark.value) {
    if (style?.backgroundTypesDark == 'solid') {
      return {
        backgroundColor: `${style?.bgColorDark ? style?.bgColorDark : '#FFFFFF'}`,
        color: `${style?.textColorDark ? style?.textColorDark : '#000000'}`,
      }
    }
    if (style?.backgroundTypesDark == 'linear') {
      return {
        background: `linear-gradient(${style?.gradientAngleDark}deg,${style?.bgColorDark},${style?.bgColorDark2})`,
        color: `${style?.textColorDark ? style?.textColorDark : '#000000'}`,
      }
    }
  } else {
    if (style?.backgroundTypes == 'solid') {
      return {
        backgroundColor: `${style?.bgColor ? style?.bgColor : '#FFFFFF'}`,
        color: `${style?.textColor ? style?.textColor : '#000000'}`,
      }
    }
    if (style?.backgroundTypes == 'linear') {
      return {
        background: `linear-gradient(${style?.gradientAngle}deg,${style?.bgColor},${style?.bgColor2})`,
        color: `${style?.textColor ? style?.textColor : '#000000'}`,
      }
    }
  }
}

onMounted(async () => {
  const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
  isDark.value = mediaQuery.matches

  // define listener and store reference
  handleSchemeChange = (e) => {
    isDark.value = e.matches
    console.log(`User switched to ${isDark.value ? 'dark' : 'light'} mode`)
  }

  mediaQuery.addEventListener('change', handleSchemeChange)
})

onBeforeUnmount(() => {
  if (mediaQuery && handleSchemeChange) {
    mediaQuery.removeEventListener('change', handleSchemeChange)
  }
})

if (isAuthenticated) {
  getUnratedOrders();
}

const closeRateOrder = async (data) => {
  rateComponent.value = false;

  let orders = [];
  if (Array.isArray(data)) {
    orders = data.map(order => order.order_id)
  } else if (data !== null && typeof data === 'object') {
    orders = [data.order_id];
  }

  const result = await useAPIHandler(
    "post",
    "/ratings/mark-order",
    {
      auth: true,
      body: orders,
    }
  );
  if (data !== null && typeof data === 'object' && unratedOrders.value.length > 1) {
    getUnratedOrders();
  }
};

onMounted(() => {
  const successMessage = localStorage.getItem('showSuccessMessage') === 'true';
  if (successMessage) {
    toast.add({
      title: 'Rating Submitted Successfully',
      timeout: 3000,
      color: 'success',
      icon: "i-heroicons-check-circle",
    })
  }

  setTimeout(() => {
    localStorage.removeItem('showSuccessMessage');
  }, 3000);
});

onBeforeRouteLeave((to, from, next) => {
  if (to.path !== '/' && rateComponent.value) {
    closeRateOrder(unratedOrders.value);
  }
  next()
})
</script>
<style>
.custom-padding > div {
  padding: 0.5rem;
}

.custom-padding>.exclude {
  padding: 0 !important;
}
</style>
